import {
  ISignInRequestDto,
  ISignInResponseDto,
  IForgotPasswordRequestDto,
  IPasswordRecoveryRequestDto,
  IPasswordSetupRequestDto,
  ISessionRefreshRequestDto,
  ISessionRefreshResponseDto,
  ISignUpRequestDto,
  ISignUpResponseDto,
  ISignUpConfirmationRequestDto,
} from './Auth.model'
import {environment} from '../../util/Environment'
import {apiSlice} from '../store/Api'

export const authApi = apiSlice.injectEndpoints({
  endpoints(builder) {
    return {
      signUp: builder.mutation<ISignUpResponseDto, ISignUpRequestDto>({
        query(body) {
          return {
            url: `${environment.apiUrl.security}/auth/signup`,
            method: 'POST',
            body,
          }
        },
      }),
      signUpConfirmation: builder.mutation<ISignUpResponseDto, ISignUpConfirmationRequestDto>({
        query(body) {
          return {
            url: `${environment.apiUrl.security}/auth/signup/confirmation`,
            method: 'POST',
            body,
          }
        },
      }),
      signIn: builder.mutation<ISignInResponseDto, ISignInRequestDto>({
        query(body) {
          return {
            url: `${environment.apiUrl.security}/auth/signin`,
            method: 'POST',
            body,
          }
        },
      }),
      refreshSession: builder.mutation<ISessionRefreshResponseDto, ISessionRefreshRequestDto>({
        query(body) {
          return {
            url: `${environment.apiUrl.security}/auth/refresh`,
            method: 'POST',
            body,
          }
        },
      }),
      forgotPassword: builder.mutation<void, IForgotPasswordRequestDto>({
        query(body) {
          return {
            url: `${environment.apiUrl.security}/auth/password/forgotten`,
            method: 'POST',
            body,
          }
        },
      }),
      passwordRecovery: builder.mutation<void, IPasswordRecoveryRequestDto>({
        query(body) {
          return {
            url: `${environment.apiUrl.security}/auth/password/recovery`,
            method: 'POST',
            body,
          }
        },
      }),
      passwordSetup: builder.mutation<ISignInResponseDto, IPasswordSetupRequestDto>({
        query(body) {
          return {
            url: `${environment.apiUrl.security}/auth/password`,
            method: 'POST',
            body,
          }
        },
      }),
    }
  },
})

export const {
  useSignUpMutation,
  useSignUpConfirmationMutation,
  useSignInMutation,
  useRefreshSessionMutation,
  useForgotPasswordMutation,
  usePasswordRecoveryMutation,
  usePasswordSetupMutation,
} = authApi
